<i class="pi pi-envelope style-icon" (click)="getTitle(emailUrl,version,type,documentNumber)"></i>
